import React, { useRef } from 'react';
import { BrandsItemProps } from '../types';
import { useIntersectionObserve } from 'common/hooks/use-intersection-observe';
import { CarouselItem, CarouselItemLink } from '../styles';
import { useTargetUrl } from 'common/hooks/use-target-url';
import { analyticsUtils } from '../../../utils/analytics-utils';

export const BrandsItem = (props: BrandsItemProps) => {
  const { brand, index, onPointerDown, analytics, onImpressionContentView } = props;
  const brandRef = useRef(null);
  const targetUrl = useTargetUrl(brand.banner);
  const contentIdViewed: number[] = [];

  const sendViewToGA = () => {
    if (analytics && !contentIdViewed.includes(index)) {
      const { elementBlock } = analytics;

      analyticsUtils.sendEvent('GA:show', {
        elementBlock,
        elementName: 'Brands',
        elementType: 'block',
        elementText: `${index + 1}`,
      });
    }

    contentIdViewed.push(index + 1);
  };

  const sendViewEvent = () => {
    if (onImpressionContentView) {
      onImpressionContentView(brand.id);
    }
    sendViewToGA();
  };

  useIntersectionObserve(brandRef, sendViewEvent, {
    threshold: 1,
  });

  return (
    <CarouselItem ref={brandRef} onPointerUp={onPointerDown}>
      <CarouselItemLink href={targetUrl} data-qa="brand">
        <picture>
          <img src={brand.banner.pictureUrl} alt={`Brand ${index}`} />
        </picture>
      </CarouselItemLink>
    </CarouselItem>
  );
};
